var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 40C31.0467 40 40.001 31.0457 40.001 20C40.001 8.95431 31.0467 0 20.001 0C8.95528 0 0.000976562 8.95431 0.000976562 20C0.000976562 31.0457 8.95528 40 20.001 40Z",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_811_2137",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9469 38.6082C30.2563 38.6082 38.6136 30.2509 38.6136 19.9416C38.6136 9.63226 30.2563 1.2749 19.9469 1.2749C9.63763 1.2749 1.28027 9.63226 1.28027 19.9416C1.28027 30.2509 9.63763 38.6082 19.9469 38.6082Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_811_2137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9447 40.1092C31.0807 40.1092 40.1081 31.0818 40.1081 19.9458C40.1081 8.80983 31.0807 -0.217651 19.9447 -0.217651C8.80873 -0.217651 -0.21875 8.80983 -0.21875 19.9458C-0.21875 31.0818 8.80873 40.1092 19.9447 40.1092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3828 31.578C17.3828 31.578 19.2885 33.2122 17.4282 34.2105C17.4282 34.2105 21.0136 35.345 23.1918 33.9379C23.1918 33.9379 21.6938 33.1668 23.1009 31.3962L17.3828 31.578Z",
    fill: "#C19786"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M17.8066 31.4587C17.8066 31.4587 19.4947 33.093 17.8473 34.0912C17.8473 34.0912 21.0214 35.2257 22.9509 33.8186C22.9509 33.8186 21.6251 33.0475 22.8708 31.277L17.8078 31.4587H17.8066Z",
    fill: "url(#paint0_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6926 53.4995L23.6152 53.4768C23.6152 53.4768 25.1442 43.4692 25.1442 40.1552C25.1442 40.1552 23.8734 34.8448 23.1932 33.9374L17.4296 34.21C17.4296 34.21 15.8862 38.6118 15.9316 40.2006C15.9316 40.2006 16.1959 45.6474 17.6938 53.4995H17.6926Z",
    fill: "#262524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4285 34.2096C17.4285 34.2096 17.0196 33.8461 15.2503 35.1624L2.45117 43.513L4.58396 43.9673L16.6024 37.1147L17.4273 34.2096H17.4285Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.708 34.1499C23.708 34.1499 24.1169 33.7864 25.8862 35.1027L38.6853 43.4533L36.5525 43.9076L24.5341 37.055L23.7092 34.1499H23.708Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1924 35.2102L19.9318 41.0789L20.7783 42.608L21.6103 41.11L22.8441 34.6877L18.1924 35.2102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0811 34.4839L20.6262 34.4086L20.3082 34.0751L20.0811 34.4839Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.886 34.3776L20.8842 34.3322L21.2166 34.9227C21.2166 34.9227 20.8077 35.982 20.7623 35.982C20.7169 35.982 20.1418 36.0429 20.1418 35.9975C20.1418 35.9521 19.5967 34.9084 19.5967 34.9084L19.8836 34.3788L19.886 34.3776Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1424 35.9972C20.1424 35.9972 20.5357 35.7401 20.7629 35.9816C20.7629 35.9816 21.852 39.4617 21.6105 41.1103L20.7784 42.6083L19.9308 41.0805C19.9308 41.0805 19.8555 39.1294 20.1424 35.9972Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4287 34.1649L18.0707 32.6072L20.3099 34.0298C20.3099 34.0298 20.0529 35.6187 18.6613 35.7693C18.6613 35.7693 17.663 35.4369 17.4287 34.1649Z",
    fill: "#EDECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5948 32.5002L20.2803 34.0436C20.2803 34.0436 21.4865 36.4072 22.4131 35.4806C22.5948 35.2989 22.8972 35.1483 23.1925 33.9372L22.5948 32.5002Z",
    fill: "#EDECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.484 44.4235C20.484 44.4235 21.2934 49.1589 19.8707 51.6097C19.8707 51.6097 19.1749 53.3348 18.6298 53.5153L17.6614 53.6361C17.6614 53.6361 15.7701 40.8071 15.7402 37.2971L17.0266 34.5438L20.484 44.4223V44.4235Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7602 33.3719L20.4836 44.4232L16.6711 35.5047L17.2151 34.7791L16.126 34.4383L17.7602 33.3719Z",
    fill: "#424141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1574 44.075C21.1574 44.075 20.6433 51.9115 21.7324 53.1214L23.699 53.1824C23.699 53.1824 25.6525 40.4908 25.5843 37.2391L23.8807 33.9395C23.8807 33.9395 21.1574 43.47 21.1574 44.075Z",
    fill: "#3A3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 33.1685L21.0723 44.4469L24.1818 35.7101L23.5231 35.1662L24.7257 34.0986L22.8655 33.1685Z",
    fill: "#424141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8489 14.8318C34.0055 16.3465 27.3513 17.8935 19.2805 17.8935C11.2096 17.8935 3.8871 16.313 4.394 14.8772C4.93915 13.3338 11.2096 12.381 19.2805 12.381C27.3513 12.381 33.7126 13.5155 33.8489 14.8318Z",
    fill: "#695447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32715 14.9081L8.56284 28.4627C8.56284 28.4627 9.66748 31.9644 11.7094 31.8066L28.5326 31.2016C28.5326 31.2016 30.9308 31.0809 31.7401 27.9188L33.9184 14.6056C33.9184 14.6056 18.5477 15.574 4.32715 14.9081Z",
    fill: "#DCC3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98361 15.0602L8.70882 27.5557C8.70882 27.5557 9.78836 31.0573 11.7849 30.8995L28.2291 30.2946C28.2291 30.2946 30.5735 30.1738 31.3637 27.0117L33.53 14.698C33.53 14.698 18.8838 15.7261 4.98242 15.0614L4.98361 15.0602Z",
    fill: "url(#paint1_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80251 15.0146C5.80251 15.0146 5.57536 19.1451 13.0186 22.4125L12.9277 20.9145C12.9277 20.9145 7.30048 19.0088 7.11876 15.1055L5.80251 15.0146Z",
    fill: "url(#paint2_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11571 15.0599L9.84083 15.1508C9.84083 15.1508 9.7954 17.6924 8.47915 18.1013C8.47915 18.1013 7.66262 17.4665 7.61719 17.2393C7.61719 17.2393 8.20777 16.1957 8.11691 15.0611L8.11571 15.0599Z",
    fill: "url(#paint3_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1567 15.1937L9.11477 15.1483C9.11477 15.1483 8.38909 17.8717 11.293 20.0953L12.2912 18.9154C12.2912 18.9154 10.0676 18.6428 11.1567 15.1937Z",
    fill: "url(#paint4_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2902 15.2388L13.6974 15.2842C13.6974 15.2842 16.5116 17.3716 13.0171 20.0949H11.292C11.292 20.0949 14.423 18.5061 12.2902 15.2388Z",
    fill: "url(#paint5_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7857 15.2388C16.7857 15.2388 15.8328 16.9639 19.4182 21.0023L20.1893 19.7315C20.1893 19.7315 17.4659 17.5078 18.1019 15.2388H16.7857Z",
    fill: "url(#paint6_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7277 15.2414C23.7277 15.2414 24.8169 17.6922 21.0498 18.7359L21.3224 19.507C21.3224 19.507 25.8605 19.2344 24.9986 15.1051L23.7277 15.2414Z",
    fill: "url(#paint7_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0882 15.0599L27.4953 15.1508C27.4953 15.1508 26.7242 18.3727 29.3555 19.8252L27.9938 20.5963C27.9938 20.5963 25.0433 17.8275 26.0882 15.0599Z",
    fill: "url(#paint8_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3565 14.9228L31.2167 14.7865C31.2167 14.7865 32.6692 18.7807 23.7734 17.9175L24.046 16.8739C24.046 16.8739 29.6733 16.5104 29.3565 14.9228Z",
    fill: "url(#paint9_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4882 14.7402C32.4882 14.7402 34.3041 14.3313 32.7153 18.9615C32.7153 18.9615 31.7625 20.6412 29.8102 20.4595L29.4014 19.1432C29.4014 19.1432 30.5359 19.4612 31.1719 18.5981C31.1719 18.5981 32.3065 16.1927 31.2173 14.7856L32.4882 14.7402Z",
    fill: "url(#paint10_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6266 17.9181C30.6266 17.9181 28.3121 14.151 24.2725 16.6018L24.6359 17.5546C24.6359 17.5546 27.3138 16.1021 29.8101 18.8255L30.6266 17.9181Z",
    fill: "url(#paint11_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9146 17.2374C20.9146 17.2374 17.964 13.5158 14.833 18.1448L15.5133 18.5991C15.5133 18.5991 18.1912 15.5577 19.9151 17.9642L20.9134 17.2386L20.9146 17.2374Z",
    fill: "url(#paint12_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4512 17.9639C26.4512 17.9639 23.6824 13.6529 18.7354 17.6459L19.5973 18.417C19.5973 18.417 22.6387 15.5119 25.4517 18.5987L26.45 17.9639H26.4512Z",
    fill: "url(#paint13_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4708 18.6003C14.4708 18.6003 14.698 14.9696 10.3858 16.6947L10.2949 17.9655C10.2949 17.9655 12.8366 16.4221 13.1091 19.1909L14.4708 18.6003Z",
    fill: "url(#paint14_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2266,
    y: 13.7872,
    width: 5.19448,
    height: 17.6612,
    fill: "url(#pattern0_811_2137)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2285,
    y: 13.6516,
    width: 5.19448,
    height: 17.6612,
    fill: "url(#pattern1_811_2137)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8291,
    y: 15.2922,
    width: 6.04449,
    height: 16.5279,
    fill: "url(#pattern2_811_2137)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1035,
    y: 23.2671,
    width: 20.3057,
    height: 7.83895,
    fill: "url(#pattern3_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4237 15.3914L19.5007 15.4213C19.5007 15.4213 15.4802 12.1683 8.96471 15.0244L7.97363 14.7327C7.97363 14.7327 12.6923 11.9041 17.0655 13.6758C17.0655 13.6758 19.4362 14.0716 20.4237 15.3902V15.3914Z",
    fill: "url(#paint15_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0944 15.2346L17.4285 15.2801C17.4285 15.2801 14.5988 12.5196 9.84543 15.1522L9.1377 14.9178C9.1377 14.9178 12.5963 12.3475 15.7106 13.8048C15.7106 13.8048 17.4106 14.1013 18.0944 15.2335V15.2346Z",
    fill: "url(#paint16_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9111 16.0237L15.4604 16.0787C15.4604 16.0787 13.6169 13.8025 10.3472 16.1492L9.875 15.9663C9.875 15.9663 12.2696 13.702 14.3354 14.8665C14.3354 14.8665 15.476 15.0781 15.9099 16.0237H15.9111Z",
    fill: "url(#paint17_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6982 13.2257L16.2475 13.2807C16.2475 13.2807 14.404 11.0044 11.1343 13.3512L10.6621 13.1683C10.6621 13.1683 12.5271 11.0941 15.266 11.9262C15.266 11.9262 16.2631 12.28 16.6982 13.2257Z",
    fill: "url(#paint18_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4629 13.4828L21.0122 13.5377C21.0122 13.5377 19.1687 11.2615 15.899 13.6083L15.4268 13.4254C15.4268 13.4254 17.2917 11.3512 20.0307 12.1832C20.0307 12.1832 21.0277 12.5371 21.4629 13.4828Z",
    fill: "url(#paint19_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 13.8158L24.2954 13.8708C24.2954 13.8708 22.4519 11.5945 19.1822 13.9413L18.71 13.7584C18.71 13.7584 20.575 11.6842 23.3139 12.5162C23.3139 12.5162 24.3109 12.8701 24.7461 13.8158Z",
    fill: "url(#paint20_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2131 14.9106L23.6583 14.8544C23.6583 14.8544 22.0635 11.6265 17.5086 13.5561L16.9922 13.2094C16.9922 13.2094 19.7897 11.2272 22.8478 12.9655C22.8478 12.9655 23.9477 13.6601 24.2131 14.9106Z",
    fill: "url(#paint21_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M24.2131 14.9106L23.6583 14.8544C23.6583 14.8544 22.0635 11.6265 17.5086 13.5561L16.9922 13.2094C16.9922 13.2094 19.7897 11.2272 22.8478 12.9655C22.8478 12.9655 23.9477 13.6601 24.2131 14.9106Z",
    fill: "url(#paint22_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.783 12.7491L27.2343 12.8483C27.2343 12.8483 24.8074 10.1883 20.965 13.3038L20.3721 13.1137C20.3721 13.1137 22.5108 10.4346 25.9312 11.2571C25.9312 11.2571 27.1805 11.6194 27.7818 12.7479L27.783 12.7491Z",
    fill: "url(#paint23_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8787 12.0542L23.33 12.1534C23.33 12.1534 20.9031 9.49339 17.0607 12.6089L16.4678 12.4188C16.4678 12.4188 18.6065 9.73966 22.0269 10.5622C22.0269 10.5622 23.2762 10.9244 23.8775 12.053L23.8787 12.0542Z",
    fill: "url(#paint24_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1765 9.84491L27.7652 10.2203C27.7652 10.2203 24.2959 9.25552 22.6963 13.9371L22.0938 14.0914C22.0938 14.0914 22.4823 10.6842 25.8166 9.56516C25.8166 9.56516 27.0683 9.2089 28.1777 9.84491H28.1765Z",
    fill: "url(#paint25_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8806 16.5199L31.3259 16.4625C31.3259 16.4625 29.7382 13.2311 25.1786 15.1498L24.6621 14.8019C24.6621 14.8019 27.4644 12.8258 30.5189 14.5712C30.5189 14.5712 31.6176 15.2682 31.8806 16.5199Z",
    fill: "url(#paint26_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4907 16.3051L30.9359 16.3636C30.9359 16.3636 29.5539 14.5154 26.4528 15.3773L24.1084 15.5435C24.1084 15.5435 26.4074 13.6032 29.756 14.6804C29.756 14.6804 30.9754 15.1346 31.4907 16.3062V16.3051Z",
    fill: "url(#paint27_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4907 16.3051L30.9359 16.3636C30.9359 16.3636 29.5539 14.5154 26.4528 15.3773L24.1084 15.5435C24.1084 15.5435 26.4074 13.6032 29.756 14.6804C29.756 14.6804 30.9754 15.1346 31.4907 16.3062V16.3051Z",
    fill: "url(#paint28_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.253 15.9599L34.7987 16.095C34.7987 16.095 32.9565 13.9539 29.3867 15.3765L28.5391 15.3155C28.5391 15.3155 30.7197 13.967 33.6271 14.5767C33.6271 14.5767 34.6923 14.8613 35.253 15.9599Z",
    fill: "url(#paint29_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3668 15.8684L33.9101 15.7393C33.9101 15.7393 33.4307 12.4493 29.0301 13.6663L28.6846 13.2658C28.6846 13.2658 31.604 11.7595 33.7332 13.8301C33.7332 13.8301 34.4804 14.6406 34.3668 15.8684Z",
    fill: "url(#paint30_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6393 16.6576L33.2244 16.4281C33.2244 16.4281 33.5066 13.1153 28.9433 13.2994L28.6982 12.8308C28.6982 12.8308 31.8843 12.0274 33.4863 14.5284C33.4863 14.5284 34.029 15.4884 33.6393 16.6576Z",
    fill: "url(#paint31_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M33.6393 16.6576L33.2244 16.4281C33.2244 16.4281 33.5066 13.1153 28.9433 13.2994L28.6982 12.8308C28.6982 12.8308 31.8843 12.0274 33.4863 14.5284C33.4863 14.5284 34.029 15.4884 33.6393 16.6576Z",
    fill: "url(#paint32_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3058 17.6114L31.9998 17.2491C31.9998 17.2491 33.4404 14.2532 29.1102 12.803L29.0469 12.2782C29.0469 12.2782 32.3106 12.6596 32.9191 15.567C32.9191 15.567 33.0865 16.6573 32.3058 17.6114Z",
    fill: "url(#paint33_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M32.3058 17.6114L31.9998 17.2491C31.9998 17.2491 33.4404 14.2532 29.1102 12.803L29.0469 12.2782C29.0469 12.2782 32.3106 12.6596 32.9191 15.567C32.9191 15.567 33.0865 16.6573 32.3058 17.6114Z",
    fill: "url(#paint34_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7946 17.0012L32.3702 16.7884C32.3702 16.7884 32.5196 13.4673 27.9683 13.8331L27.7041 13.3753C27.7041 13.3753 30.8555 12.4463 32.5567 14.8816C32.5567 14.8816 33.1377 15.8189 32.7946 17.0024V17.0012Z",
    fill: "url(#paint35_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1038 16.0978L32.6304 16.1229C32.6304 16.1229 31.1109 13.1652 27.3415 15.7427L26.8848 15.4761C26.8848 15.4761 29.1586 13.1054 31.8449 14.375C31.8449 14.375 32.8145 14.8999 33.1038 16.0978Z",
    fill: "url(#paint36_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M33.1038 16.0978L32.6304 16.1229C32.6304 16.1229 31.1109 13.1652 27.3415 15.7427L26.8848 15.4761C26.8848 15.4761 29.1586 13.1054 31.8449 14.375C31.8449 14.375 32.8145 14.8999 33.1038 16.0978Z",
    fill: "url(#paint37_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0233 15.045L22.2091 15.1334C22.2091 15.1334 17.2011 11.6844 11.1196 15.3749L10.0986 15.2159C10.0986 15.2159 14.4025 11.7896 18.9717 12.9696C18.9717 12.9696 21.8696 13.8674 23.0233 15.045Z",
    fill: "url(#paint38_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9582 9.61169C26.9582 9.61169 21.9204 11.6536 21.4434 15.4207L22.1463 15.557C22.1463 15.557 22.4416 12.1079 27.8644 10.3601C27.8644 10.3601 27.2966 9.61169 26.957 9.61169H26.9582Z",
    fill: "url(#paint39_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9582 9.55005C26.9582 9.55005 21.9204 11.592 21.4434 15.359L22.1463 15.4953C22.1463 15.4953 22.4416 12.0463 27.8644 10.2984C27.8644 10.2984 27.2966 9.55005 26.957 9.55005H26.9582Z",
    fill: "url(#paint40_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5303 15.1917L11.4831 15.3734C11.4831 15.3734 18.8809 8.42991 24.5536 8.65586C24.5536 8.65586 30.3626 9.42696 28.5932 15.328L29.864 15.2371C29.864 15.2371 32.224 9.42816 25.0987 7.70304C25.0987 7.70304 19.0172 6.65936 10.5303 15.1917Z",
    fill: "url(#paint41_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52246 15.105L7.31269 15.1588C7.31269 15.1588 8.09336 9.03422 15.3895 10.739C23.0623 12.5311 21.8333 15.319 21.8333 15.319L23.1113 15.2652C23.1113 15.2652 23.2177 11.0582 15.7625 9.83282C8.30735 8.60743 7.02936 11.4838 6.52246 15.105Z",
    fill: "url(#paint42_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0884 15.2639C12.0884 15.2639 11.1834 7.64851 7.24182 9.88531C3.30142 12.1221 5.64462 14.9447 5.64462 14.9447L6.52332 15.1049C6.52332 15.1049 4.31282 12.7079 7.66861 10.5787C7.66861 10.5787 10.184 9.03889 11.303 15.4827L11.6807 15.619L12.0884 15.2651V15.2639Z",
    fill: "url(#paint43_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1456 13.4896C23.1456 13.4896 20.9363 21.8474 8.73134 22.0817C-2.39884 22.2945 1.16975 15.0521 1.16975 15.0521C1.16975 15.0521 2.94508 11.5373 7.31227 15.1585L6.07014 15.1406C6.07014 15.1406 3.34438 13.6869 2.23615 15.9033C1.22475 17.9273 2.50274 19.3643 2.50274 19.3643C2.50274 19.3643 4.20635 21.0679 8.59147 20.9089C14.3191 20.6997 18.3552 19.3117 22.4378 13.4179C22.4378 13.4179 22.8634 12.9564 23.148 13.4884L23.1456 13.4896Z",
    fill: "url(#paint44_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M23.1456 13.4896C23.1456 13.4896 20.9363 21.8474 8.73134 22.0817C-2.39884 22.2945 1.16975 15.0521 1.16975 15.0521C1.16975 15.0521 2.94508 11.5373 7.31227 15.1585L6.07014 15.1406C6.07014 15.1406 3.34438 13.6869 2.23615 15.9033C1.22475 17.9273 2.50274 19.3643 2.50274 19.3643C2.50274 19.3643 4.20635 21.0679 8.59147 20.9089C14.3191 20.6997 18.3552 19.3117 22.4378 13.4179C22.4378 13.4179 22.8634 12.9564 23.148 13.4884L23.1456 13.4896Z",
    fill: "url(#paint45_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M23.1456 13.4896C23.1456 13.4896 20.9363 21.8474 8.73134 22.0817C-2.39884 22.2945 1.16975 15.0521 1.16975 15.0521C1.16975 15.0521 2.94508 11.5373 7.31227 15.1585L6.07014 15.1406C6.07014 15.1406 3.34438 13.6869 2.23615 15.9033C1.22475 17.9273 2.50274 19.3643 2.50274 19.3643C2.50274 19.3643 4.20635 21.0679 8.59147 20.9089C14.3191 20.6997 18.3552 19.3117 22.4378 13.4179C22.4378 13.4179 22.8634 12.9564 23.148 13.4884L23.1456 13.4896Z",
    fill: "url(#paint46_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.406 13.4467C22.406 13.4467 22.1012 12.6362 21.3911 13.4527C21.3911 13.4527 13.2807 20.6891 7.13941 19.3406C0.996884 17.992 2.95034 13.5184 4.76034 13.2339C4.76034 13.2339 5.68327 13.1634 5.54101 14.0146L6.07301 14.2632C6.07301 14.2632 6.29538 12.4879 4.61688 12.4879C2.93839 12.4879 1.66995 14.1915 1.63409 16.4283C1.59822 18.6651 4.79382 20.2623 7.20755 20.4751C9.62128 20.6879 16.0125 20.1906 22.4025 13.4455L22.406 13.4467Z",
    fill: "url(#paint47_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M22.406 13.4467C22.406 13.4467 22.1012 12.6362 21.3911 13.4527C21.3911 13.4527 13.2807 20.6891 7.13941 19.3406C0.996884 17.992 2.95034 13.5184 4.76034 13.2339C4.76034 13.2339 5.68327 13.1634 5.54101 14.0146L6.07301 14.2632C6.07301 14.2632 6.29538 12.4879 4.61688 12.4879C2.93839 12.4879 1.66995 14.1915 1.63409 16.4283C1.59822 18.6651 4.79382 20.2623 7.20755 20.4751C9.62128 20.6879 16.0125 20.1906 22.4025 13.4455L22.406 13.4467Z",
    fill: "url(#paint48_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8797 13.651C18.8797 13.651 16.8677 13.1118 16.3871 15.4777L16.3691 15.663L17.035 15.2374C17.035 15.2374 17.2777 14.3277 18.6083 14.1806L18.8809 13.651H18.8797Z",
    fill: "url(#paint49_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3222 14.299C20.3222 14.299 19.6504 13.7036 18.2122 14.4137C16.774 15.1239 14.041 17.9644 8.50225 18.1234C2.96346 18.2836 5.46686 14.0407 6.46032 14.4664C6.46032 14.4664 6.46869 13.5877 5.53739 13.7741C4.85954 13.9092 4.40644 14.1448 3.94019 15.5578C3.35439 17.3332 5.33415 18.9913 7.45498 19.2053C9.55908 19.4181 11.6883 19.6046 18.3461 15.4777C18.3461 15.4777 19.1626 14.7365 19.642 14.8429L20.3222 14.2978V14.299Z",
    fill: "url(#paint50_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M20.3222 14.299C20.3222 14.299 19.6504 13.7036 18.2122 14.4137C16.774 15.1239 14.041 17.9644 8.50225 18.1234C2.96346 18.2836 5.46686 14.0407 6.46032 14.4664C6.46032 14.4664 6.46869 13.5877 5.53739 13.7741C4.85954 13.9092 4.40644 14.1448 3.94019 15.5578C3.35439 17.3332 5.33415 18.9913 7.45498 19.2053C9.55908 19.4181 11.6883 19.6046 18.3461 15.4777C18.3461 15.4777 19.1626 14.7365 19.642 14.8429L20.3222 14.2978V14.299Z",
    fill: "url(#paint51_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6119 15.3967C16.6119 15.3967 14.3249 8.49978 8.94629 10.6565C8.94629 10.6565 5.89296 11.8819 7.31323 15.1564L8.28039 15.1827C8.28039 15.1827 6.9486 12.4928 9.42569 11.4288C11.9016 10.3636 14.5628 12.5322 15.7619 15.4086L16.6131 15.3979L16.6119 15.3967Z",
    fill: "url(#paint52_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M16.6119 15.3967C16.6119 15.3967 14.3249 8.49978 8.94629 10.6565C8.94629 10.6565 5.89296 11.8819 7.31323 15.1564L8.28039 15.1827C8.28039 15.1827 6.9486 12.4928 9.42569 11.4288C11.9016 10.3636 14.5628 12.5322 15.7619 15.4086L16.6131 15.3979L16.6119 15.3967Z",
    fill: "url(#paint53_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0426 15.3172L15.7085 15.3435C15.7085 15.3435 14.2703 9.45916 9.90433 11.2692C9.90433 11.2692 7.48104 12.4946 8.27963 15.1833L9.13203 15.2371C9.13203 15.2371 8.21508 12.8963 10.3299 11.9088C13.1788 10.577 15.149 14.8641 15.0426 15.3172Z",
    fill: "url(#paint54_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4878 15.4311C15.4878 15.4311 13.7651 10.5235 9.87726 13.5589C9.87726 13.5589 9.02486 14.4914 9.13126 15.2362H9.84976C9.84976 15.2362 9.90356 14.3312 10.4093 13.9845C10.915 13.6378 13.1793 12.2462 14.7502 15.4418L15.4878 15.4311Z",
    fill: "url(#paint55_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.103 15.41C15.1759 15.5248 14.4455 15.41 14.4455 15.41C14.4455 15.41 11.4495 11.6705 9.53195 13.5606C9.53195 13.5606 8.99995 14.2791 8.94615 15.1853H8.09375C8.09375 15.1853 8.27666 13.8033 8.89235 13.135C9.53195 12.4428 12.5195 11.3369 15.103 15.41Z",
    fill: "url(#paint56_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5642 15.2636H13.7118C13.7118 15.2636 12.2736 13.2671 10.4636 14.3048C10.4636 14.3048 9.90413 14.6778 10.0105 15.2636L9.13184 15.2373C9.13184 15.2373 9.21194 14.4124 10.0906 13.9593C10.9693 13.5062 12.1146 12.7076 14.5642 15.2636Z",
    fill: "url(#paint57_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0828 15.466C16.0828 15.466 15.8664 14.2968 14.4641 14.5598C13.1992 14.7965 11.6965 16.7739 9.82551 16.8265C7.95454 16.8791 6.34658 16.5635 7.53253 14.9818C7.53253 14.9818 7.11051 14.4546 6.6359 15.0081C6.16128 15.5616 5.39735 18.4081 10.1411 17.6179C10.1411 17.6179 11.6702 17.5127 14.6745 15.3512C14.6745 15.3512 15.0391 15.1025 15.326 15.4516L16.0828 15.4672V15.466Z",
    fill: "url(#paint58_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M16.0828 15.466C16.0828 15.466 15.8664 14.2968 14.4641 14.5598C13.1992 14.7965 11.6965 16.7739 9.82551 16.8265C7.95454 16.8791 6.34658 16.5635 7.53253 14.9818C7.53253 14.9818 7.11051 14.4546 6.6359 15.0081C6.16128 15.5616 5.39735 18.4081 10.1411 17.6179C10.1411 17.6179 11.6702 17.5127 14.6745 15.3512C14.6745 15.3512 15.0391 15.1025 15.326 15.4516L16.0828 15.4672V15.466Z",
    fill: "url(#paint59_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1428 15.1675C12.1428 15.1675 12.67 14.614 13.0657 15.2464C13.0657 15.2464 9.84983 18.4623 8.32078 16.9332C8.32078 16.9332 7.00333 15.721 7.74096 14.9559C7.74096 14.9559 8.05776 14.6654 8.37338 15.0874C8.37338 15.0874 8.53118 16.2996 9.21741 16.6164C9.90243 16.9332 11.6419 15.8788 12.1428 15.1663V15.1675Z",
    fill: "url(#paint60_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M12.1428 15.1675C12.1428 15.1675 12.67 14.614 13.0657 15.2464C13.0657 15.2464 9.84983 18.4623 8.32078 16.9332C8.32078 16.9332 7.00333 15.721 7.74096 14.9559C7.74096 14.9559 8.05776 14.6654 8.37338 15.0874C8.37338 15.0874 8.53118 16.2996 9.21741 16.6164C9.90243 16.9332 11.6419 15.8788 12.1428 15.1663V15.1675Z",
    fill: "url(#paint61_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0242 15.0449C23.0242 15.0449 25.5348 11.0986 28.3705 11.3962C31.2075 11.6939 32.3014 12.031 34.5334 13.9809C34.5334 13.9809 39.5234 17.2602 34.1723 20.6327C34.1723 20.6327 35.2913 20.8372 35.9967 20.4426C35.9967 20.4426 37.087 19.8987 37.4421 18.2561C37.7971 16.6134 37.1862 13.474 32.8441 11.4704C32.8441 11.4704 28.0131 9.43201 25.2527 11.4333C25.2527 11.4333 23.2813 12.8559 22.2627 15.1202L23.0242 15.0461V15.0449Z",
    fill: "url(#paint62_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M23.0242 15.0449C23.0242 15.0449 25.5348 11.0986 28.3705 11.3962C31.2075 11.6939 32.3014 12.031 34.5334 13.9809C34.5334 13.9809 39.5234 17.2602 34.1723 20.6327C34.1723 20.6327 35.2913 20.8372 35.9967 20.4426C35.9967 20.4426 37.087 19.8987 37.4421 18.2561C37.7971 16.6134 37.1862 13.474 32.8441 11.4704C32.8441 11.4704 28.0131 9.43201 25.2527 11.4333C25.2527 11.4333 23.2813 12.8559 22.2627 15.1202L23.0242 15.0461V15.0449Z",
    fill: "url(#paint63_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0229 15.0461C22.9954 15.3115 24.2949 14.8656 24.2949 14.8656C24.2949 14.8656 26.509 11.939 29.3698 11.4966C29.3698 11.4966 27.3793 10.6371 24.919 12.8033C24.919 12.8033 23.06 14.6934 23.0229 15.0449V15.0461Z",
    fill: "url(#paint64_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M23.0229 15.0461C22.9954 15.3115 24.2949 14.8656 24.2949 14.8656C24.2949 14.8656 26.509 11.939 29.3698 11.4966C29.3698 11.4966 27.3793 10.6371 24.919 12.8033C24.919 12.8033 23.06 14.6934 23.0229 15.0449V15.0461Z",
    fill: "url(#paint65_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.514 18.9848C35.514 18.9848 37.1076 16.7647 34.15 14.2697C34.15 14.2697 32.6054 12.7765 30.8492 12.896C30.8492 12.896 29.7852 12.8398 26.9984 14.5327C24.2117 16.2267 21.6605 16.0235 21.6605 16.0235C21.6605 16.0235 20.0465 15.7389 20.129 15.6146C20.1517 15.5811 20.9575 14.8997 21.0364 14.7861C21.0364 14.7861 21.5816 15.2631 23.1692 15.0587C23.1692 15.0587 24.0981 15.1866 28.3972 12.7514C28.3972 12.7514 30.4594 11.8619 31.4326 11.9564C32.1021 12.0281 37.5799 14.8447 36.639 17.6697C36.639 17.6697 35.8763 18.7576 35.514 18.9848Z",
    fill: "url(#paint66_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M35.5316 18.9848C35.5316 18.9848 37.1252 16.7647 34.1675 14.2697C34.1675 14.2697 32.6229 12.7765 30.8667 12.896C30.8667 12.896 29.8027 12.8398 27.016 14.5327C24.2293 16.2267 21.6781 16.0235 21.6781 16.0235C21.6781 16.0235 20.0641 15.7389 20.1466 15.6146C20.1693 15.5811 20.9751 14.8997 21.054 14.7861C21.054 14.7861 21.5992 15.2631 23.1868 15.0587C23.1868 15.0587 24.1157 15.1866 28.4147 12.7514C28.4147 12.7514 30.477 11.8619 31.4501 11.9564C31.8542 11.8452 37.4372 14.7335 36.6566 17.6697C36.6566 17.6697 35.8938 18.7576 35.5316 18.9848Z",
    fill: "url(#paint67_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3697 11.4952C29.3697 11.4952 26.1454 12.4923 24.5088 14.6717C24.5088 14.6717 27.4115 13.4786 28.3978 12.7493C28.3978 12.7493 30.4744 11.7798 31.4332 11.9543C31.4332 11.9543 29.7403 11.4247 29.3697 11.4952Z",
    fill: "url(#paint68_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3697 11.4952C29.3697 11.4952 26.1454 12.4923 24.5088 14.6717C24.5088 14.6717 27.4115 13.4786 28.3978 12.7493C28.3978 12.7493 30.4744 11.7798 31.4332 11.9543C31.4332 11.9543 29.7403 11.4247 29.3697 11.4952Z",
    fill: "url(#paint69_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1635 15.6616C37.9172 12.0368 31.6169 9.89563 29.0955 10.5914C29.0955 10.5914 37.6255 12.4026 37.1724 16.1457C37.1724 16.1457 37.2632 17.7573 34.9033 19.5266C34.8124 19.6426 33.9266 20.0479 33.5189 20.0718C30.1607 20.5261 28.0949 15.2611 28.0949 15.2611C27.7996 14.9622 27.4959 14.9753 27.1875 15.2611C29.2294 21.5698 33.4281 20.9565 33.4281 20.9565C33.8429 20.9146 34.4622 20.752 34.8352 20.5703C35.9099 20.067 38.3547 18.4543 38.1647 15.6604L38.1635 15.6616Z",
    fill: "url(#paint70_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9219 11.1422C31.7185 9.63828 28.9103 10.5636 28.9103 10.5636C29.1159 10.4907 31.4161 10.988 31.4161 10.988C32.8399 11.3311 33.6027 12.1309 33.6027 12.1309C34.4909 12.9725 34.6965 15.4437 33.6983 16.4192C33.47 16.7025 31.9134 18.8007 28.7967 15.2165C28.7967 15.2165 28.2288 14.559 28.0938 15.2619C28.0938 15.2619 31.4519 20.8211 34.5615 17.1006L34.5555 17.0935C36.0523 15.134 35.7952 12.4214 33.9219 11.1446V11.1422Z",
    fill: "url(#paint71_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.9219 11.1422C31.7185 9.63828 28.9103 10.5636 28.9103 10.5636C29.1159 10.4907 31.4161 10.988 31.4161 10.988C32.8399 11.3311 33.6027 12.1309 33.6027 12.1309C34.4909 12.9725 34.6965 15.4437 33.6983 16.4192C33.47 16.7025 31.9134 18.8007 28.7967 15.2165C28.7967 15.2165 28.2288 14.559 28.0938 15.2619C28.0938 15.2619 31.4519 20.8211 34.5615 17.1006L34.5555 17.0935C36.0523 15.134 35.7952 12.4214 33.9219 11.1446V11.1422Z",
    fill: "url(#paint72_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.093 15.2391C29.093 15.2391 29.2293 14.7393 29.8868 14.9438L30.3184 15.1936C30.3184 15.1936 33.4434 17.4723 34.15 14.2683L34.3795 14.468C34.3795 14.468 34.5158 16.1249 33.0178 17.0096C33.0178 17.0096 30.5216 16.9869 29.0918 15.2391H29.093Z",
    fill: "url(#paint73_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 11.4267L35.309 11.9037C35.309 11.9037 36.2618 8.06854 28.3428 9.13493C28.3428 9.13493 29.0457 9.7028 29.1593 9.97418C29.1593 9.97418 34.4925 9.36088 34.3335 11.4267Z",
    fill: "url(#paint74_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0459 15.0425C30.0459 15.0425 30.5002 14.8906 31.0143 15.1034C31.5283 15.3151 33.3443 15.8602 33.7376 15.2852C33.7376 15.2852 32.7394 17.0402 30.0459 15.0437V15.0425Z",
    fill: "url(#paint75_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63443 15.0089C6.63443 15.0089 6.32719 14.3586 5.41262 14.991C5.41262 14.991 3.6349 16.5906 5.77845 17.645C5.77845 17.645 4.41079 16.3264 6.63324 15.0089H6.63443Z",
    fill: "#A98757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9457 16.2822C25.9457 16.2822 25.3253 17.1597 26.5052 16.978C26.5052 16.978 32.753 13.2408 27.5645 9.62561C27.5645 9.62561 22.4513 6.46349 18.5635 14.2546C19.068 14.1076 19.5163 14.0131 19.857 14.1028C19.857 14.1028 22.376 8.77799 26.9595 10.5175C26.9595 10.5175 30.6656 12.8929 25.9457 16.281V16.2822Z",
    fill: "url(#paint76_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M25.9457 16.2822C25.9457 16.2822 25.3253 17.1597 26.5052 16.978C26.5052 16.978 32.753 13.2408 27.5645 9.62561C27.5645 9.62561 22.4513 6.46349 18.5635 14.2546C19.068 14.1076 19.5163 14.0131 19.857 14.1028C19.857 14.1028 22.376 8.77799 26.9595 10.5175C26.9595 10.5175 30.6656 12.8929 25.9457 16.281V16.2822Z",
    fill: "url(#paint77_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6659 14.0577L20.3215 14.2956C20.3215 14.2956 20.1518 14.1031 19.8565 14.1031C19.8565 14.1031 19.2133 9.21709 17.1415 9.67019C14.9633 10.1472 14.6297 12.0002 14.6297 12.0002C14.6297 12.0002 14.2065 11.6225 14.0547 11.4862C14.0547 11.4862 14.9477 9.26252 16.9741 8.9744C16.9741 8.9744 20.0597 8.08136 20.6659 14.0577Z",
    fill: "url(#paint78_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M20.6659 14.0577L20.3215 14.2956C20.3215 14.2956 20.1518 14.1031 19.8565 14.1031C19.8565 14.1031 19.2133 9.21709 17.1415 9.67019C14.9633 10.1472 14.6297 12.0002 14.6297 12.0002C14.6297 12.0002 14.2065 11.6225 14.0547 11.4862C14.0547 11.4862 14.9477 9.26252 16.9741 8.9744C16.9741 8.9744 20.0597 8.08136 20.6659 14.0577Z",
    fill: "url(#paint79_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6659 14.0592L20.832 13.9229C20.832 13.9229 20.9982 6.28358 17.4428 7.9023C17.4428 7.9023 16.4146 8.35659 16.1875 9.17313C16.1875 9.17313 16.7171 8.94598 17.1559 8.94598C17.1559 8.94598 17.8971 8.43191 18.7746 8.65906C18.7746 8.65906 19.8338 8.7798 20.6659 14.0604V14.0592Z",
    fill: "url(#paint80_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M20.6659 14.0592L20.832 13.9229C20.832 13.9229 20.9982 6.28358 17.4428 7.9023C17.4428 7.9023 16.4146 8.35659 16.1875 9.17313C16.1875 9.17313 16.7171 8.94598 17.1559 8.94598C17.1559 8.94598 17.8971 8.43191 18.7746 8.65906C18.7746 8.65906 19.8338 8.7798 20.6659 14.0604V14.0592Z",
    fill: "url(#paint81_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1421 10.0211C16.0883 10.0486 15.8397 13.0314 17.4285 14.8474L17.9127 14.5903C17.9127 14.5903 16.6873 12.8054 16.9599 9.71863C16.9599 9.71863 16.6729 9.74852 16.1433 10.0211H16.1421Z",
    fill: "url(#paint82_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6338 15.2392C16.6338 15.2392 9.93892 10.2468 12.6623 8.74881C12.6623 8.74881 14.379 7.96217 16.1866 9.17202C16.1866 9.17202 15.8387 9.31548 15.5435 9.56534C15.5435 9.56534 14.2726 8.70338 13.07 9.3382C13.07 9.3382 12.4351 9.79249 13.4107 11.1087C13.4107 11.1087 15.2183 13.6205 17.3511 14.9368C17.3511 14.9368 16.837 15.2847 16.6326 15.2392H16.6338Z",
    fill: "url(#paint83_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0762 15.3754C10.0762 15.3754 10.2806 14.8756 10.9381 15.2618C11.5957 15.6479 12.9573 17.3037 15.2049 16.6008C17.4513 15.8978 18.4579 15.2092 18.4579 15.2092C18.4579 15.2092 19.0628 15.0119 18.9875 15.3754C18.9875 15.3754 16.5212 17.055 15.3412 17.5081C15.3412 17.5081 11.8694 18.5518 10.0762 15.3754Z",
    fill: "url(#paint84_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M10.0762 15.3754C10.0762 15.3754 10.2806 14.8756 10.9381 15.2618C11.5957 15.6479 12.9573 17.3037 15.2049 16.6008C17.4513 15.8978 18.4579 15.2092 18.4579 15.2092C18.4579 15.2092 19.0628 15.0119 18.9875 15.3754C18.9875 15.3754 16.5212 17.055 15.3412 17.5081C15.3412 17.5081 11.8694 18.5518 10.0762 15.3754Z",
    fill: "url(#paint85_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38077 15.118C8.38077 15.118 8.20383 13.8794 8.91755 13.9595C9.39695 14.0133 9.92895 14.6254 9.92895 14.6254C9.92895 14.6254 11.7127 16.9423 16.9047 15.2112C16.9047 15.2112 15.9722 15.9297 15.6004 16.0361C15.2286 16.1425 11.788 18.3662 8.37957 15.118H8.38077Z",
    fill: "url(#paint86_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M8.38077 15.118C8.38077 15.118 8.20383 13.8794 8.91755 13.9595C9.39695 14.0133 9.92895 14.6254 9.92895 14.6254C9.92895 14.6254 11.7127 16.9423 16.9047 15.2112C16.9047 15.2112 15.9722 15.9297 15.6004 16.0361C15.2286 16.1425 11.788 18.3662 8.37957 15.118H8.38077Z",
    fill: "url(#paint87_linear_811_2137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4713 18.407C23.4713 18.407 22.7743 17.2869 21.5752 17.2558C21.5752 17.2558 21.6433 16.7058 22.2758 16.8326C22.9082 16.9593 23.6996 17.7722 23.6996 17.7722C23.6996 17.7722 23.9602 18.4561 23.4713 18.407Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_811_2137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2709 23.4395C23.3233 23.4395 24.1765 22.5863 24.1765 21.5338C24.1765 20.4814 23.3233 19.6282 22.2709 19.6282C21.2184 19.6282 20.3652 20.4814 20.3652 21.5338C20.3652 22.5863 21.2184 23.4395 22.2709 23.4395Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.0495 22.4568C22.5553 22.4568 22.9653 22.0468 22.9653 21.541C22.9653 21.0352 22.5553 20.6252 22.0495 20.6252C21.5438 20.6252 21.1338 21.0352 21.1338 21.541C21.1338 22.0468 21.5438 22.4568 22.0495 22.4568Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3844 17.6144C16.3844 17.6144 15.0682 17.7052 14.4788 18.7489C14.4788 18.7489 14.0245 18.4309 14.4333 17.9324C14.8422 17.4327 15.9313 17.1158 15.9313 17.1158C15.9313 17.1158 16.657 17.2067 16.3856 17.6156L16.3844 17.6144Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_811_2137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7631 24.1035C17.8155 24.1035 18.6687 23.2503 18.6687 22.1979C18.6687 21.1454 17.8155 20.2922 16.7631 20.2922C15.7106 20.2922 14.8574 21.1454 14.8574 22.1979C14.8574 23.2503 15.7106 24.1035 16.7631 24.1035Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.0574 23.092C17.5631 23.092 17.9731 22.682 17.9731 22.1763C17.9731 21.6705 17.5631 21.2605 17.0574 21.2605C16.5516 21.2605 16.1416 21.6705 16.1416 22.1763C16.1416 22.682 16.5516 23.092 17.0574 23.092Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_811_2137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4361 24.7104C21.4062 25.5043 20.7522 26.1403 19.9512 26.1403C19.1503 26.1403 18.4963 25.5043 18.4664 24.7104H18.0205C18.0504 25.7493 18.904 26.5862 19.9512 26.5862C20.9985 26.5862 21.8521 25.7493 21.882 24.7104H21.4361Z",
    fill: "#231F20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_811_2137",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_811_2137",
    transform: "scale(0.0181818 0.00531915)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_811_2137",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_811_2137",
    transform: "scale(0.0178571 0.00529101)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_811_2137",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_811_2137",
    transform: "scale(0.0153846 0.00564972)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_811_2137",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_811_2137",
    transform: "scale(0.00460829 0.0119048)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_811_2137",
    x: 18.7771,
    y: 18.4938,
    width: 6.08022,
    height: 6.07998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.45374
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.567175
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0 0.152941 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_2137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_2137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_811_2137",
    x: 13.2693,
    y: 19.1579,
    width: 6.08022,
    height: 6.07998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.45374
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.567175
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0 0.152941 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_2137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_2137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_811_2137",
    x: 17.6802,
    y: 24.7104,
    width: 4.31507,
    height: 2.32947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.113435,
    dy: 0.22687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.113435
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0 0.152941 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_2137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_2137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_811_2137",
    x1: 21.5904,
    y1: 30.5382,
    x2: 19.1157,
    y2: 34.8241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F3E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_811_2137",
    x1: 19.258,
    y1: 14.6968,
    x2: 19.258,
    y2: 30.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_811_2137",
    x1: 9.40936,
    y1: 15.0146,
    x2: 9.40936,
    y2: 22.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_811_2137",
    x1: 8.72781,
    y1: 15.0599,
    x2: 8.72781,
    y2: 18.1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_811_2137",
    x1: 10.6629,
    y1: 15.1483,
    x2: 10.6629,
    y2: 20.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_811_2137",
    x1: 13.0303,
    y1: 15.2388,
    x2: 13.0303,
    y2: 20.0949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_811_2137",
    x1: 18.4295,
    y1: 15.2388,
    x2: 18.4295,
    y2: 21.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_811_2137",
    x1: 23.0786,
    y1: 15.1051,
    x2: 23.0786,
    y2: 19.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_811_2137",
    x1: 27.6101,
    y1: 15.0599,
    x2: 27.6101,
    y2: 20.5963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_811_2137",
    x1: 27.5393,
    y1: 14.7865,
    x2: 27.5393,
    y2: 18.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_811_2137",
    x1: 31.3847,
    y1: 14.7306,
    x2: 31.3847,
    y2: 20.4726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_811_2137",
    x1: 27.4501,
    y1: 15.7733,
    x2: 27.4501,
    y2: 18.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_811_2137",
    x1: 17.8744,
    y1: 15.8231,
    x2: 17.8744,
    y2: 18.5991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_811_2137",
    x1: 22.5933,
    y1: 15.9495,
    x2: 22.5933,
    y2: 18.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_811_2137",
    x1: 12.3835,
    y1: 16.2296,
    x2: 12.3835,
    y2: 19.1909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB884A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_811_2137",
    x1: 7.97363,
    y1: 14.2569,
    x2: 20.4237,
    y2: 14.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_811_2137",
    x1: 9.1365,
    y1: 14.3189,
    x2: 18.0944,
    y2: 14.3189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_811_2137",
    x1: 9.875,
    y1: 15.3411,
    x2: 15.9111,
    y2: 15.3411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_811_2137",
    x1: 10.6621,
    y1: 12.5406,
    x2: 16.6982,
    y2: 12.5406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_811_2137",
    x1: 15.4268,
    y1: 12.7977,
    x2: 21.4629,
    y2: 12.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_811_2137",
    x1: 18.71,
    y1: 13.1295,
    x2: 24.7461,
    y2: 13.1295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_811_2137",
    x1: 16.9922,
    y1: 13.58,
    x2: 24.2131,
    y2: 13.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_811_2137",
    x1: 16.9922,
    y1: 13.58,
    x2: 24.2131,
    y2: 13.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_811_2137",
    x1: 20.3721,
    y1: 12.2016,
    x2: 27.783,
    y2: 12.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_811_2137",
    x1: 16.4678,
    y1: 11.5078,
    x2: 23.8787,
    y2: 11.5078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_811_2137",
    x1: 22.0926,
    y1: 11.778,
    x2: 28.1765,
    y2: 11.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_811_2137",
    x1: 24.6633,
    y1: 15.1845,
    x2: 31.8806,
    y2: 15.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_811_2137",
    x1: 24.1072,
    y1: 15.3594,
    x2: 31.4907,
    y2: 15.3594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_811_2137",
    x1: 24.1072,
    y1: 15.3594,
    x2: 31.4907,
    y2: 15.3594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_811_2137",
    x1: 28.5391,
    y1: 15.257,
    x2: 35.253,
    y2: 15.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_811_2137",
    x1: 28.6846,
    y1: 14.3035,
    x2: 34.3788,
    y2: 14.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_811_2137",
    x1: 28.6982,
    y1: 14.6838,
    x2: 33.7804,
    y2: 14.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_811_2137",
    x1: 28.6982,
    y1: 14.6838,
    x2: 33.7804,
    y2: 14.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_811_2137",
    x1: 29.0469,
    y1: 14.9454,
    x2: 32.9347,
    y2: 14.9454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_811_2137",
    x1: 29.0469,
    y1: 14.9454,
    x2: 32.9347,
    y2: 14.9454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_811_2137",
    x1: 27.7053,
    y1: 15.1016,
    x2: 32.9034,
    y2: 15.1016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62451F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A37742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_811_2137",
    x1: 26.886,
    y1: 15.0624,
    x2: 33.1038,
    y2: 15.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_811_2137",
    x1: 26.886,
    y1: 15.0624,
    x2: 33.1038,
    y2: 15.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_811_2137",
    x1: 10.0986,
    y1: 14.0491,
    x2: 23.0233,
    y2: 14.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_811_2137",
    x1: 21.4446,
    y1: 12.5837,
    x2: 27.8668,
    y2: 12.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_811_2137",
    x1: 26.5123,
    y1: 9.24041,
    x2: 22.5946,
    y2: 16.0237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_811_2137",
    x1: 24.8859,
    y1: 7.09333,
    x2: 17.7906,
    y2: 19.3832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_811_2137",
    x1: 6.52246,
    y1: 12.4331,
    x2: 23.1113,
    y2: 12.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_811_2137",
    x1: 4.95242,
    y1: 12.5453,
    x2: 12.0884,
    y2: 12.5453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_811_2137",
    x1: 0.6246,
    y1: 17.6595,
    x2: 23.1456,
    y2: 17.6595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_811_2137",
    x1: 0.6246,
    y1: 17.6595,
    x2: 23.1456,
    y2: 17.6595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_811_2137",
    x1: 11.8851,
    y1: 13.2338,
    x2: 11.8851,
    y2: 22.0865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_811_2137",
    x1: 1.63648,
    y1: 16.5012,
    x2: 22.406,
    y2: 16.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_811_2137",
    x1: 1.63648,
    y1: 16.5012,
    x2: 22.406,
    y2: 16.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_811_2137",
    x1: 16.3679,
    y1: 14.6301,
    x2: 18.8797,
    y2: 14.6301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_811_2137",
    x1: 3.83618,
    y1: 16.5226,
    x2: 20.3222,
    y2: 16.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_811_2137",
    x1: 3.83618,
    y1: 16.5226,
    x2: 20.3222,
    y2: 16.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_811_2137",
    x1: 6.93545,
    y1: 12.8239,
    x2: 16.6119,
    y2: 12.8239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_811_2137",
    x1: 11.7737,
    y1: 15.4086,
    x2: 11.7737,
    y2: 10.2392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_811_2137",
    x1: 8.11824,
    y1: 13.133,
    x2: 15.7085,
    y2: 13.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D592E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_811_2137",
    x1: 9.12289,
    y1: 14.0048,
    x2: 15.4878,
    y2: 14.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_811_2137",
    x1: 8.09375,
    y1: 13.9587,
    x2: 15.1078,
    y2: 13.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_811_2137",
    x1: 9.13303,
    y1: 14.3693,
    x2: 14.5642,
    y2: 14.3693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_811_2137",
    x1: 6.27844,
    y1: 16.1391,
    x2: 16.0828,
    y2: 16.1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_811_2137",
    x1: 6.27844,
    y1: 16.1391,
    x2: 16.0828,
    y2: 16.1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_811_2137",
    x1: 7.5174,
    y1: 16.1024,
    x2: 13.0657,
    y2: 16.1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_811_2137",
    x1: 7.5174,
    y1: 16.1024,
    x2: 13.0657,
    y2: 16.1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_811_2137",
    x1: 22.2627,
    y1: 15.6188,
    x2: 37.5281,
    y2: 15.6188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CDB46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_811_2137",
    x1: 22.2627,
    y1: 15.6188,
    x2: 37.5281,
    y2: 15.6188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_811_2137",
    x1: 23.0217,
    y1: 13.2289,
    x2: 29.3698,
    y2: 13.2289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_811_2137",
    x1: 23.0217,
    y1: 13.2289,
    x2: 29.3698,
    y2: 13.2289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_811_2137",
    x1: 20.1254,
    y1: 15.4676,
    x2: 36.749,
    y2: 15.4676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_811_2137",
    x1: 20.143,
    y1: 15.4676,
    x2: 36.7319,
    y2: 15.4676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_811_2137",
    x1: 24.5076,
    y1: 13.0805,
    x2: 31.4332,
    y2: 13.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_811_2137",
    x1: 24.5076,
    y1: 13.0805,
    x2: 31.4332,
    y2: 13.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_811_2137",
    x1: 27.1863,
    y1: 15.7178,
    x2: 38.1742,
    y2: 15.7178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_811_2137",
    x1: 28.0949,
    y1: 14.3318,
    x2: 35.5238,
    y2: 14.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCB985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_811_2137",
    x1: 28.0949,
    y1: 14.3318,
    x2: 35.5238,
    y2: 14.3318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_811_2137",
    x1: 29.093,
    y1: 15.6384,
    x2: 34.3831,
    y2: 15.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_811_2137",
    x1: 28.3428,
    y1: 10.4261,
    x2: 35.3461,
    y2: 10.4261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CDB46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_811_2137",
    x1: 30.0459,
    y1: 15.4932,
    x2: 33.7376,
    y2: 15.4932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_811_2137",
    x1: 24.0939,
    y1: 17.0031,
    x2: 24.0939,
    y2: 8.99199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEB868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_811_2137",
    x1: 18.5623,
    y1: 12.9969,
    x2: 29.6243,
    y2: 12.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CDB46F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_811_2137",
    x1: 14.0547,
    y1: 11.6117,
    x2: 20.6659,
    y2: 11.6117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_811_2137",
    x1: 14.0547,
    y1: 11.6117,
    x2: 20.6659,
    y2: 11.6117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5A3B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_811_2137",
    x1: 16.1887,
    y1: 10.8684,
    x2: 20.8332,
    y2: 10.8684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_811_2137",
    x1: 16.1887,
    y1: 10.8684,
    x2: 20.8332,
    y2: 10.8684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_811_2137",
    x1: 16.0955,
    y1: 12.2818,
    x2: 17.9115,
    y2: 12.2818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_811_2137",
    x1: 12.0107,
    y1: 11.8715,
    x2: 17.3523,
    y2: 11.8715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_811_2137",
    x1: 10.0762,
    y1: 16.3939,
    x2: 18.9935,
    y2: 16.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_811_2137",
    x1: 10.0762,
    y1: 16.3939,
    x2: 18.9935,
    y2: 16.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_811_2137",
    x1: 8.36164,
    y1: 15.4169,
    x2: 16.9059,
    y2: 15.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A37742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_811_2137",
    x1: 8.36164,
    y1: 15.4169,
    x2: 16.9059,
    y2: 15.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDB46F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3B2314"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_811_2137",
    width: 55,
    height: 188,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAC8CAYAAADcrDZdAAAACXBIWXMAAA4mAAAOJgGi7yX8AAAK5ElEQVR4nO1d7XLjNhCDkuv7P2/vYrs/6nWgFXa5lCkynSlmNJJoyyaC/aSUZMMiPB6P7Xm40XBrjMcftN9t27Y9/IdMw+Px+MD3ZKMNOBKzcyNyp/2dzh/btj1+Xc7E4anYBuAj2DbaQ+yBPanbc9vca5hODt8KfDy//9NtTM4TY/MzYva+r+cYzCxXkMNzMp/P77fNyCn1gL2PmQnye+7u/cvImQl+AvgLRwUjcko10Pnumqnknv7GxH5Bq2cK7i5HTIwVf2Glcp4YK+h9Dvgmx8SYLAckAOsCiiln21/Pzfudbawakza/sw1YSM4CCW9skqwcT9abJJ7nnxC+ZlhBzqumSB5MDHtids6+6c14qVlmJD25B44Vijdd0GsA1iqnyEXKcQ77xNHXfJIHsIZcq/xi8nzd/Xn8cJ/xo5SLiPkqxSZuahgBI8+ll2wAVteWmXIqDVQK6/nKUTfgt6w7YHI28YzgDiuV4wlyPenJAd/+dof+AUmsipaV/efzGlOLA0nW4C4JKN4MFSHbTEm7TinWxGxyHAl9axOZJJArF2I2OT95tbzAxwCZGTpUA9aYpTLDzIeAY/nl8foB2BIDMD+gKH+L0gOw97so7Pslvt2XzYIiE5EFNLFovg81OJOcITND9QPg6zz8usqdX1xZOPf4XISU3BTlROn1Ca0YoIn54GJ7T2w+uVVY3c/1mKRXz2+vZXTDLOWiCiQiCJzzu2Xk/Gpyixhf20rektwss/Q1ZMU8DTKHEe7RCyvMsupvWcQEjqQPP4SZ5JRS1eqkYpa8BzA3FVSUypTzaJnrVOXs+5RKUQCpRMsQs82SjzPVgAEKXk7OPbUQEWwl8VbO+/fpBerlgHXN6pnoyGMqgPyIaNlrnhHCJtUwg1yWrP37ehG2O8Acs7TSK4qU0cpxFlD8KrQR3GGWcty/RffVotTAUFVJqNxqs6wmblVrpkUzMJdclriBNkGFHxktW8m7NS9Pamm05O9rEVXXqcmHpPjLrkZPqZUhMsE1PidKr56SS34kgvZGnC/1uUjBswHlgBXRkrcP9x6+BojNL1PwhavJGQG18lX1vYzQa9x3BMAcctFDolGAycxSlV3LUoEnExXPLT+LSB0WYhlXk1MmmRGsmOXuKXQak19+NdjvemvKVqEsb4AYZpilj44VtTyiewM/ilyrvozM0vaK4A0LzdKgimNFZsPRj1RjGt6XM1xGrlF6ZeO7j3FbNCYx0yzVOcRrEThCAgWCV5LLctuZPOf3y1e/RhLj82ZHYF9+FUy16GlzoE4QqJHc4cqlPasrozzniVWTerMbMFypXM/zXb3z+HEtT6vNaXUD4bhqd4A50VJt6plKQJM2NM3QYzY5BHtPqprUly8zALU0UImYHvOT+MkbjkCbYFQ8S6zyuVaplYGjZFg0A9eR48CRNarRba0I0VKDxIo8B3EMdxwFE9uXgsqVyvlfOlLhP+sIevxP4ipy1YWh3lxnKOW8K5VTxDL/qwSZUqtj+Cn9XIQmASwIKL1P51VI+vPlytm+GjVbaaCi5AtX57lqIq/kNj82v5+j0qsVHaO9/Nhoi9odm8Bo+AqkpwTz4zzxiGCIq8zSP1TTSxKIl/CWkjNC0T25iEzFLK1QvqFRNAPXkqtEyWoKiG6C3ILrAFxDLrpNfHYNUxF7ILkBwhMZDU+mYpIQ48qf+AbIsoDSk+cywj/uRshZYi3/A46pIcWV5Pi4pdZwYsDaNRRAk6ykBD4PMZQc/Q09HzGrqSH86M5xAGvy3BlfO4Ur7vJUVIM4ZmTlmD9OJzISXHapv9/V43NZeuB9OpmR2HAklVUqfF2EULGs3QGuIRf5HN9Z7fW9qPVJcQW5aoT013lk6yZLfK6a11qh30OVXmlHAFxDjo9bFUmFZEQs7QiA61qezPcMFR9Te+4MmhMZguRPXymT7Ppo2nf53UjlIpP0r6lzD6+Manmmm2VPFeKhknNXoexxRYWSPTDaIpsRXJoKopKrgtaqcvR6c0KjUEng2eRagUOdpxjZFbRCP8R5VIX481O+N1q5SuWv0FoEKq94MWaUX/xahozYgWirIwCuyXNZj8bwZOxY/UJEd6QErjHL6FwhUssvvpaeRvcYQo7uyQG578nLaZ8RvKHT70Yp1+qyFUEV/UIfw/7uTrPdAcanAtV5V6t/RVD9zk6p3QHGVygqgQN1/4uCyVJyPZXJhrg4zkyyO9eNMssN8XNerVRgx9U8l/5CIGNkQGmRqua71lbGFXkua3laqJCansQjQr2kWufljsAmNRo9lUrWFUSmuCyJZ+ZYCSzRWLe/AQPINUovoGaamUKn/A0Yn8Q9IUWwVbFESr7GK+2OTehdtArlalBhqEi5rOXx+c0+t7cFYmTRszypd5El8FaV4pGlhCXK8ZJe9bZVpRzzr3GdWZ7Yu/DKReuWvVE0qy1LuCrPVcuv3gqmXDQD48wyInSmHPPmyf+Px5YbyhMbhSqhauOqzpckcUXobLTk4+5imfEWueINR0a1Ujl8FTrTADB3Of2d9ocxLVrapP1/bWk9EsVEfZKGOF+mnP8tfi7BqnmtlcBP4V1yLbXOJG7bK+W6J/cOvElWntCLUFooqrY7wBhy0YNrQJtUS6mlq1+Rj/VES0XIL8R233gExpLrDf8qQasimQmWSy9g7gJRBE9EKdh1X84wSjl/rsYUIpNUxMo3QAynyQWrXnBj4eXIg8cdR/VumOxz9hlni+SsIfVbd0B55y5PVJWo1w1R1Z+ZpVeyjJHRUp23kPlZFGjKGFF+ZVEyK5AVscgku5YXeHJnYTVl9hftDT35zMZutN1RfLDGT/AsVOmVmWWrtIoUY5JdeDeg+IJZrTQzKqUW/7Lt6RwHvEfO/zaxIhYVvcqfFBlPtAunyNHaSfTwaOZvdpxVITccfW5aQFF9XPZQTS8xJngHcOsNJsB5s1SRskWuFUB2ZGj7wolgApwn5/89fRYxVRrwvnTDkeR8ck9/+8D3f26vqsbHWcj/wgB/A84pZ8T439JHOY7J2HgUHb1Zvkie8TfgHLlPHFVT6lWqfqUUj502SaCT3NMkmVzFLIG9WbaCh9/mkMN3lPTkMn+7P9+j/M0IKvXMJLuTt6GXXNUkAe1nXrkvcWyK/cEbqgEd5J6/4M6ry/5f0e/ejly1yL/Udho9ym3YR0lWzJB11kAe8m3sz3P/9Y5JAkVySSDxK8zAPvTb3pukMkG/f8skgbpynLR/4aha1Mp4H1SR0RMbYpJAgRxVJFHo93mNTclUA9ohfxf+zyZuRkU5M0mvmhH0OcyvZyqTVKrx9rZqQIOcU80TM0K298qpetKUYxKe2J9t264nh71qKjr6yXsfZOWUr9n2m7Y/p9k4hORINXXn1AhExFT0tEpEEePzt8I/I1POr25Fqt3cuRHdsCfG5IyQ33+NCCQGSc49X6LCPvuQve8Le3/k93KkVKb4G//62tu5jREpx4EkioqmkE3oTteBxnyk9Ob4Um0EIcaBnHgqCNAti0/QkU/63o3J/Y1v1Yb5mkEpFy3TmXmxWlwc83WqMfX5jaPjcGKAI5eoxoHCE+NgE0XJzCyHVCMKWbT0gYPHTa3KwlBEbkjln8GTi9Ti8ai2VGnCAopcG7mSGEDknibJCZjDuI37Gx5ArBp/xmGF6ypTZCiz9DcsbF9ZcFWfw8HlMv9S2P3UC08oHK7BftHVj39fNJHU//iv4x8JngvGHvfoDwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_811_2137",
    width: 56,
    height: 189,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_811_2137",
    width: 65,
    height: 177,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_811_2137",
    width: 217,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANkAAABUCAYAAAAPkJJwAAAACXBIWXMAAA4mAAAOJgGi7yX8AAAF80lEQVR4nO2d63KbSBBGv5Esr7PZ93/PvSR2LFnsD2irafVwkSCWrXOqKBEEI1LFcff0DCABAAAAAAAAAAAAzKFpmvLR5wAAAAAAN0nTNMXSxc1HnwzAVwfJABYmFjyQDGAd3kVDMoDlIZIBrIVLFYlkACtRukWllEZCMoClMcko4QMsTZYqSkgGsCRFiVNIBrAclipuJPpkAGtQwiIJyQAWoeuP9eQykAxgGSxNRDKAldioL1njvwCAK+hSRRPsTLKHjzgpgC9GkbTVKWgxTgawMJYqbkW6CLAKvj/GYDTAkjRNY4J50YqIZACLUdTWNixVPBsro/ABcB1bnYoeG7kIZiAZwIV0pXsTbNttLpIam7cokS4CXMNG/VRRko7d0tsJAC5j6xYkA1gSN8vD0kU/PtbrlyEZwGVYVdGX741eJKPwAXAZW7X+mGhSMgNfIpIBXIpJ5tPFsylVEpEMYDbdLA8fxWIEo08GcCUbSTv1B6Hfp1L5MTKJSAZwCT5VtEFoE+sYdyaSAcygK917wXyqeJT0Fo8hkgHMw8bG/IRg4yhpnx0AANPZqt8f8zM9zgaiJSQDmEtWupdauUy0HqSLABPpSvc79SWTToK9lVIofABcgaWKfjqVle7TooeEZABzsFQxCtaoFeyQHYRkABOolO4tgllfLI1k9MkApuFL93HWvZctPRAAxtlKetT5fEWLYGnRQ0IygKnsdBofy9LFtD8mIRnAKG7WfW1s7E3Sa+14JAMYx6eKPop5ydKih4RkAFOwe8fiALTJdaj1xyQkAxjEle6zu5+tL1btj0lIBjBGLN3P6o9ZAwBQ50H90r103her9sckJAMYw5fus/7Yfqg/JiEZQJWmaR6Uz7q3KLZXcpNmBMkAErqxsSdJ33RKF/0Nmge1gg32xyQkAzijqyg+Sfrefe50HsUOkl7HUkWJCcIAPboI9k3SX5L+lPSHWsmK+lOo9pJ+TWkTyQA6uj7Yk06CxSjWGxsrpQyOjxlIBndPF70e1Uaw7zr1w6yqKJ2imBU7nqe2j2Rwtzi5rMDxpDY99PMUpfM08VUTCh4GksHdkchlYtkSy/UWwV7V9sN+xEdxD4FkcBe49zvv1Mrlo5ZPDTPBDjoJ9rOUMjmKSUgGX5yumGG3qjyqFcvkstkcQ0+f8oI9S/o59xyQDL4ULmKZWDv1o5UXK87kiIJZmd7k+nvKuFgEyeBT46Ty7wyzSb1eKD89Kr7yKHuUgEWvF7WC/XOJYFLl9ZsAt0pXtPC3n5hUXqKHsF4TK7ttxSqIL93yLOnfUsroHMUaSAY3SyeUT/98xIqRKS4b1cWyyqB/MKkXzKeIPy6NYAaSwYfjZPJi2LM0skdjR5n8/plU/jr3z+aw1NDPqLc08b9SyqRpU2MgGaxO12+yZZMstt1kKm57jEpRxihSJpbUF8vfbGli+ZkcL3PGwcZAMriaLhJJfTm8JP67+EJz/+kjUpTS71sTqXda6r9i1su11yk1tPTwRe0DSheTy0AyOKOLPIat+wvdtsfoYdEoRin/vU/r4ndxu5LfyCJUtsRn1Ps+l1UPX9RO9F1cLA+SfVGCKEYWBeJFnB0THyYT9x9KA+OyCev+d/xn3P7+X3OfvnBxDOtvbt36Xr/UyrVKxKqBZL+BygU/RrzoaxdhbVtGLSWrteP3mdIHyiJU3Cd7tJrCeiaAj1AxWu3deizFH/SbpYqsJlnTNGXOf+zCCzFj6KJZqt218ZEh/vY1wsb+zVj7MVLVUrdadIxtKOxn+NTO96X8pxfI72uPZLMq4fHakvvS3EwkG5Bs7jkO/cWf28ZS7c393aG+zyXt+XZiKpe1mx1XO5dsWxaRsnP3hQlL7zLR/Ev2Dm7/5iMj1FRuRrK5jEi5lBhDf6HXILuAs8+57dn6mDDZcbV9a8fGit6QBD7t26v/tsp32T6DSEN8WskuYUZKOvSXPH6/BmMX/TXnMNYPG2p7ynnF1M7+bbyv31patxZ3JdlaTJB3iYi6NL7NKZHCIkvvXO5FFAC4Yf4HSY3hc2Vrjn4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImage);
export default __webpack_public_path__ + "static/media/Logo-Image.bdbb60440c694053fb5de201ff8260c4.svg";
export { ForwardRef as ReactComponent };